import classNames from "classnames";
import PropTypes from "prop-types";
import { ReactComponent as CheckIcon } from "../../Assets/icons/check.svg";

const Checkbox = ({
  label,
  subLabel,
  children,
  errors,
  touched,
  icon,
  required,
  checked,
  onChange,
  variant = "default",
  ...rest
}) => {
  const inputId = `checkbox-${label ? label.replace(/\s+/g, "-").toLowerCase() : "consent"
    }`;

  // Madelin variant with children (special style for self-employed)
  if (variant === "madelin") {
    const handleClick = () => {
      if (onChange) {
        onChange(!checked);
      }
    };

    return (
      <div className="miltis__checkbox miltis__checkbox--madelin">
        <button
          type="button"
          className={classNames("miltis__checkbox--box", {
            "miltis__checkbox--box--checked": checked,
          })}
          onClick={handleClick}
        >
          {checked && <CheckIcon />}
        </button>
        <div
          className="miltis__checkbox--text"
          onClick={handleClick}
          style={{ cursor: "pointer" }}
        >
          {children || label}
        </div>
      </div>
    );
  }

  // Consent variant with children
  if (variant === "consent" || children) {
    const handleClick = () => {
      if (onChange) {
        onChange(!checked);
      }
    };

    return (
      <div className="miltis__checkbox miltis__checkbox--consent">
        <button
          type="button"
          className={classNames("miltis__checkbox--box", {
            "miltis__checkbox--box--checked": checked,
          })}
          onClick={handleClick}
        >
          {checked && <CheckIcon />}
        </button>
        <div
          className="miltis__checkbox--text"
          onClick={handleClick}
          style={{ cursor: "pointer" }}
        >
          {children || label}
        </div>
      </div>
    );
  }

  // Default checkbox variant
  return (
    <label
      className={classNames("miltis__checkbox", {
        "miltis__checkbox--error": touched && errors,
      })}
      htmlFor={inputId}
    >
      <input
        id={inputId}
        type="checkbox"
        className={classNames({ "disable--input": rest.disabled })}
        checked={checked}
        onChange={(e) => onChange && onChange(e.target.checked)}
        {...rest}
      />
      <div className="miltis__checkbox--label">
        <div className="miltis__checkbox--label--text">{label}</div>
        {subLabel && (
          <div className="miltis__checkbox--label--subLabel">{subLabel}</div>
        )}
      </div>
    </label>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf(["default", "consent", "madelin"]),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  label: "",
  subLabel: "",
  variant: "default",
};

export default Checkbox;
